/**
 * Created by Ning Jiang on 2021-11-02.
 */

import {TombstoneRipReelView} from "../../reels/TombstoneRipReelView";
import {TombstoneRip} from "../../TombstoneRip";
import {Layers, TombstoneRipLayers} from "../../view/TombstoneRipLayers";
import {TombstoneRipBackground} from "../../view/TombstoneRipBackground";
import {gsap} from "gsap";
import {TombstoneRipSound} from "../../sound/TombstoneRipSound";

export class ScatterLandingView {

    private _nearWinBlend:PIXI.spine.Spine;
    private _nearWinNormal:PIXI.spine.Spine;
    private _nearWinSmoke:PIXI.spine.Spine;
    private _nearWinReel:number = -1;

    private _nearWin4Tl:TimelineLite | null;
    private _nearWin5Tl:TimelineLite | null;

    constructor() {}

    public playNearWin4():void {
        this._nearWinReel = 3;
        if(!this._nearWinNormal) {
            this._nearWinNormal = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("nearWin"));
            this._nearWinNormal.autoUpdate = true;
            this._nearWinNormal.visible = false;
            TombstoneRipLayers.getLayer(Layers.NEAR_WIN)!.addChild(this._nearWinNormal);
        }
        if(!this._nearWinBlend) {
            this._nearWinBlend = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("nearWinBlend"));
            this._nearWinBlend.autoUpdate = true;
            this._nearWinBlend.visible = false;
            TombstoneRipLayers.getLayer(Layers.NEAR_WIN)!.addChild(this._nearWinBlend);
        }

        const positionX = TombstoneRipReelView.REEL_AREAS[3].x;
        const positionY = TombstoneRipReelView.REEL_AREAS[3].y + TombstoneRipReelView.REEL_AREAS[3].height * 0.5;
        this._nearWinNormal.position.set(positionX, positionY);
        this._nearWinBlend.position.set(positionX, positionY);

        const nearWinTl = gsap.timeline();
        nearWinTl.add(() => {
            TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.SCATTER_ANTICIPATION_FS, repeat : 100});
            TombstoneRipSound.fadeMusic(0, 200);
        });
        nearWinTl.add(() => {
            if(this._nearWinReel === 3) {
                this._nearWinNormal.state.setAnimation(0, "nearWin", true);
                this._nearWinNormal.visible = true;
                this._nearWinBlend.state.setAnimation(0, "nearWin", true);
                this._nearWinBlend.visible = true;
            }
        }, 0.633);
        nearWinTl.add(() => {
            if(this._nearWinReel === 3) {
                TombstoneRipBackground.shakeStageOnce();
            }
        }, 0.767);
        this._nearWin4Tl = nearWinTl;
    }

    public playNearWin5():void {
        this._nearWinReel = 4;

        if(this._nearWin4Tl && this._nearWin4Tl.isActive()) {
            this._nearWin4Tl.pause();
            this._nearWin4Tl.kill();
        }
        this._nearWin4Tl = null;
        TombstoneRipSound.soundPlayer.stopTrack(TombstoneRipSound.SCATTER_ANTICIPATION_FS);

        if(!this._nearWinSmoke) {
            this._nearWinSmoke = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("nearWinSmoke"));
            this._nearWinSmoke.autoUpdate = true;
            this._nearWinSmoke.visible = false;
            TombstoneRipLayers.getLayer(Layers.NEAR_WIN)!.addChildAt(this._nearWinSmoke, 0);
        }

        if(!this._nearWinBlend) {
            this._nearWinBlend = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("nearWinBlend"));
            this._nearWinBlend.autoUpdate = true;
            this._nearWinBlend.visible = false;
            TombstoneRipLayers.getLayer(Layers.NEAR_WIN)!.addChild(this._nearWinBlend);
        }

        const positionX = TombstoneRipReelView.REEL_AREAS[4].x;
        const positionY = TombstoneRipReelView.REEL_AREAS[4].y + TombstoneRipReelView.REEL_AREAS[4].height * 0.5;
        this._nearWinNormal.position.set(positionX, positionY);
        this._nearWinBlend.position.set(positionX, positionY);
        this._nearWinSmoke.position.set(positionX, positionY);

        const nearWinTl = gsap.timeline();
        nearWinTl.add(() => {TombstoneRipSound.soundPlayer.playTrack({
            name : TombstoneRipSound.SCATTER_ANTICIPATION_FS_SUPER,
            repeat : 100
        })});
        nearWinTl.add(() => {
            if(this._nearWinReel === 4) {
                this._nearWinNormal.state.setAnimation(0, "501", false);
                this._nearWinNormal.visible = true;
                this._nearWinBlend.state.setAnimation(0, "nr501", false);
                this._nearWinBlend.visible = true;
            }
        }, 0);
        nearWinTl.add(() => {
            if(this._nearWinReel === 4) {
                this._nearWinNormal.state.setAnimation(0, "502", false);
                this._nearWinNormal.visible = true;
                this._nearWinBlend.state.setAnimation(0, "nr502", false);
                this._nearWinBlend.visible = true;
            }
        }, 0.533);
        nearWinTl.add(() => {
            if(this._nearWinReel === 4) {
                this._nearWinNormal.state.setAnimation(0, "503", false);
                this._nearWinNormal.visible = true;
                this._nearWinBlend.state.setAnimation(0, "nr503", false);
                this._nearWinBlend.visible = true;
            }
        }, 1.533);
        nearWinTl.add(() => {
            if(this._nearWinReel === 4) {
                this._nearWinSmoke.state.setAnimation(0, "smoke", true);
                this._nearWinSmoke.visible = true;
            }
        }, 0.733);

        // shake
        nearWinTl.add(() => {
            if(this._nearWinReel === 4) {
                TombstoneRipBackground.shakeStageOnce();
            }
        }, 0.133);
        nearWinTl.add(() => {
            if(this._nearWinReel === 4) {
                TombstoneRipBackground.shakeStageOnce();
            }
        }, 0.667);
        nearWinTl.add(() => {
            if(this._nearWinReel === 4) {
                TombstoneRipBackground.shakeStageOnce();
            }
        }, 1.667);


        this._nearWin5Tl = nearWinTl;
    }

    public stopNearWin(playFailSound:boolean):void {
        if(this._nearWinReel != -1) {
            TombstoneRipSound.fadeAndStopSound({
                name : TombstoneRipSound.SCATTER_ANTICIPATION_FS,
                to : 0,
                duration : 100
            });
            TombstoneRipSound.fadeAndStopSound({
                name : TombstoneRipSound.SCATTER_ANTICIPATION_FS_SUPER,
                to : 0,
                duration : 100
            });
            if(playFailSound) {
                TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.SCATTER_ANTICIPATION_FAIL});
            }
            if(!TombstoneRip.model.parsedGameData.freespinTriggeredThisSpin) {
                TombstoneRipSound.fadeMusic(1, 200);
            }
        }

        this._nearWinReel = -1;

        if(this._nearWin4Tl && this._nearWin4Tl.isActive()) {
            this._nearWin4Tl.pause();
            this._nearWin4Tl.kill();
        }
        this._nearWin4Tl = null;

        if(this._nearWin5Tl && this._nearWin5Tl.isActive()) {
            this._nearWin5Tl.pause();
            this._nearWin5Tl.kill();
        }
        this._nearWin5Tl = null;

        TombstoneRipBackground.stopStageMove();

        if(this._nearWinNormal) {
            this._nearWinNormal.state.clearTrack(0);
            this._nearWinNormal.skeleton.setToSetupPose();
            this._nearWinNormal.state.setEmptyAnimation(0, 0);
            this._nearWinNormal.visible = false;

        }
        if(this._nearWinBlend) {
            this._nearWinBlend.state.clearTrack(0);
            this._nearWinBlend.skeleton.setToSetupPose();
            this._nearWinBlend.state.setEmptyAnimation(0, 0);
            this._nearWinBlend.visible = false;
        }

        if(this._nearWinSmoke) {
            this._nearWinSmoke.state.clearTrack(0);
            this._nearWinSmoke.skeleton.setToSetupPose();
            this._nearWinSmoke.state.setEmptyAnimation(0, 0);
            this._nearWinSmoke.visible = false;
        }
    }
}